module.exports = __webpack_public_path__ + "img/mac.486d45c2.svg";